
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'AgeLimit16'
})
export default class AgeLimit16 extends Vue {}
